import { Component } from '@angular/core';
import { IDFooterModule } from '@inera/ids-angular/components/footer';
import { IDLinkModule } from '@inera/ids-angular/components/link';
import { IDMobileMenuModule } from '@inera/ids-angular/components/mobile/menu';
import { IDIconArrowModule } from '@inera/ids-angular/icons/arrow';
import { IDIconExternalModule } from '@inera/ids-angular/icons/external';

@Component({
  selector: 'app-footer',
  imports: [IDFooterModule, IDLinkModule, IDIconArrowModule, IDMobileMenuModule, IDIconExternalModule],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
})
export class AppFooterComponent {}
